import { SfccRefundMethod } from "@redotech/cockroachdb-codegen/congodb/sfcc-refund-method";
import type { infer as zInfer } from "zod";
import * as z from "zod";

export const getCommerceCloudRefundMethod = {
  name: "getCommerceCloudRefundMethod" as const,
  input: z.object({}),
  output: z.union([
    z.object({ refundMethod: z.enum(SfccRefundMethod) }),
    z.undefined(),
  ]),
};

export type CommerceCloudRefundMethod = zInfer<
  typeof getCommerceCloudRefundMethod.output
>;
